// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { TrailingStopOrderEdit } from "../order-edit/TrailingStopOrderEdit.js"
import { InstrumentUtils } from "../../../../Utils/Instruments/InstrumentUtils.js"
import { OrderEditUpdateData } from "../../../../Utils/Trading/OrderEditUpdateData.js"
import { TIF } from "../../../../Utils/Trading/OrderTif.js"
import { OrderUtils } from "../../../../Utils/Trading/OrderUtils.js"
import { Quantity } from "../../../../Utils/Trading/Quantity.js"
import { OrderExecutorUtils } from "../../../Trading/OrderExecutorUtils.js"
import { BoundToEdit } from "../BoundToEdit.js"
import { OrderSLTPEdit } from "../OrderSLTPEdit.js"

// TODO. Ugly. Refactor. Lots of duplicated pieces of code 
// (sltp, boundTo parameters and whatnot).
export let ModifyTrailingStopOrder = function (data)
{
    TrailingStopOrderEdit.call(this, data)

    let order = data.order

    this.sltpBasePriceGetter = this.sltpBasePriceGetter.bind(this)

    this.order = order
    this.sltp = new OrderSLTPEdit(data, true)
    this.boundToEdit = new BoundToEdit()

    this.updateParameters(new OrderEditUpdateData(
        null,
        {
            instrument: order.Instrument,
            account: order.Account,
            side: order.BuySell,
            quantity: new Quantity(order.Amount, true),
            tif: new TIF(order.TimeInForce, new Date(order.ExpireAt)),
            order: order
        }
    ))
}

ModifyTrailingStopOrder.prototype = Object.create(TrailingStopOrderEdit.prototype)

ModifyTrailingStopOrder.prototype.getParameterNameArray = function () 
{
    let paramNameArr = TrailingStopOrderEdit.prototype.getParameterNameArray.call(this)
    paramNameArr.push('boundTo')
    return paramNameArr
}

ModifyTrailingStopOrder.prototype.dispose = function ()
{
    TrailingStopOrderEdit.prototype.dispose.call(this)
    this.order = null
}

// TODO. Refactor.
ModifyTrailingStopOrder.prototype.setTradingData = function (tradingDataDict)
{
    let newTradingDataDict =
        TrailingStopOrderEdit.prototype.setTradingData.call(this, tradingDataDict)

    if (!newTradingDataDict)
        return newTradingDataDict

    if ('order' in tradingDataDict)
    {
        this.order = tradingDataDict.order
        newTradingDataDict.order = this.order
    }

    return newTradingDataDict
}

// TODO. Refactor base class, trading data. Ugly.
ModifyTrailingStopOrder.prototype.getTradingData = function ()
{
    let tradingDataDict = TrailingStopOrderEdit.prototype.getTradingData.call(this)
    tradingDataDict.order = this.order
    return tradingDataDict
}

// TODO. Refactor base class, trading data. Ugly.
ModifyTrailingStopOrder.prototype.getDataForRequest = function ()
{
    let reqData = TrailingStopOrderEdit.prototype.getDataForRequest.call(this)
    if (reqData)
        reqData.order = this.order

    return reqData
}



ModifyTrailingStopOrder.prototype.update_trailingStop = function (updateData)
{
    let parameterChanged =
        TrailingStopOrderEdit.prototype.update_trailingStop.call(this, updateData)

    let newTradingDataDict = updateData.newTradingDataDict
    if (!newTradingDataDict)
        return parameterChanged

    let order = newTradingDataDict.order
    if (!order)
        return parameterChanged

    let newTicks = InstrumentUtils.getPriceDifferenceInTicks(
        order.Price,
        this.getQuotePriceForCalculatingOffset(),
        this.instrument)

    let newTrStopVal = OrderUtils.ConvertTickOffset(
        this.instrument,
        this.trailingStop.offsetViewMode,
        0,
        newTicks)

    if (newTrStopVal !== this.trailingStop.value)
    {
        this.trailingStop.value = newTrStopVal
        parameterChanged |= true
    }

    return parameterChanged
}

ModifyTrailingStopOrder.prototype.update_boundTo = function (updateData)
{
    return this.boundToEdit.update(updateData)
}

ModifyTrailingStopOrder.prototype.toDynProperty_boundTo = function ()
{
    return this.boundToEdit.getDynProperty()
}

ModifyTrailingStopOrder.prototype.toRawValue_boundTo = function ()
{
    return this.boundToEdit.getRawValue()
}

// TODO. UGLY. Refactor. details are at the top OrderEditBase.js
ModifyTrailingStopOrder.prototype.setSLTP = function (sltpHolder)
{
    let dp = this.sltp.createDynPropertyForRawSLTP(
        sltpHolder,
        this.getTradingData(),
        this.sltpBasePriceGetter,
        this.sltpBasePriceGetter)

    this.updateParameters(new OrderEditUpdateData({ sltp: dp }))
}

ModifyTrailingStopOrder.prototype.sltpBasePriceGetter = function ()
{
    return this.order ? this.order.Price : 0
}

ModifyTrailingStopOrder.prototype.getLeverageValue = function ()
{
    return this.order ? this.order.Leverage : null;
}

// TODO. Ugly. Duplication.
ModifyTrailingStopOrder.prototype.getConfirmationText = function (onlyParams = false)
{
    const confrimationText = TrailingStopOrderEdit.prototype.getConfirmationText.call(this);
    if (onlyParams)
        return confrimationText;
    else
        return OrderExecutorUtils.getModifyOrderEditConfirmation(
            this.order,
            confrimationText
        );
}